import { Box, Skeleton, Stack } from '@mui/material'
import type { FC, PropsWithChildren } from 'react'
import { type To } from 'react-router'

import { COLORS, unit } from '@hcr/ui'

import { LayoutNavigationBack } from '../../../../common'
import { AdditionalInfoListLoading } from '../additional-info-list'

interface LayoutTicketDetailsLoadingProps extends PropsWithChildren {
  backNavigationPath: To
}

export const LayoutTicketDetailsLoading: FC<LayoutTicketDetailsLoadingProps> = ({ backNavigationPath }) => {
  return (
    <LayoutNavigationBack to={backNavigationPath} arrowVariant='text'>
      <Box sx={{ overflowX: 'clip' }}>
        <Stack
          sx={{
            p: `${unit(24)} ${unit(7)} ${unit(7.5)}`,
            backgroundColor: COLORS.white,
          }}
        >
          <Stack sx={{ gap: unit(8.5), paddingBottom: unit(8.5) }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: unit(2) }}>
              <Skeleton width={unit(20)} height={unit(6)} />
            </Box>
            <Skeleton width='100%' height={unit(10)} variant='rectangular' />
          </Stack>
          <Skeleton width='100%' height={unit(60)} />
        </Stack>
        <Stack sx={{ gap: unit(5), padding: `${unit(5)} ${unit(7)}` }}>
          <AdditionalInfoListLoading />
          <Skeleton width='100%' height={unit(12)} variant='rectangular' />
        </Stack>
      </Box>
    </LayoutNavigationBack>
  )
}
